/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpiglead3Inputs */

const en_crosspostinghelpiglead3 = /** @type {(inputs: Crosspostinghelpiglead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On Meta, Instagram always works through a Facebook Page.`)
};

const de_crosspostinghelpiglead3 = /** @type {(inputs: Crosspostinghelpiglead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Meta läuft Instagram immer über eine Facebook-Seite.`)
};

/**
* | output |
* | --- |
* | "On Meta, Instagram always works through a Facebook Page." |
*
* @param {Crosspostinghelpiglead3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpiglead3 = /** @type {((inputs?: Crosspostinghelpiglead3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpiglead3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpiglead3(inputs)
	return de_crosspostinghelpiglead3(inputs)
});
export { crosspostinghelpiglead3 as "crosspostingHelpIgLead" }